import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { GameProvider, useGame } from '@/context/GameContext'
import StudentLogin from '@/components/StudentLogin'
import GameWorld from '@/components/GameWorld'
import TeacherDashboard from '@/components/teacher/TeacherDashboard'

function StudentApp() {
  const { student, isTeacher } = useGame()
  // Teacher who navigates to /play should go to their dashboard
  if (isTeacher) return <Navigate to="/teacher" replace />
  if (!student) return <StudentLogin />
  return <GameWorld />
}

function TeacherApp() {
  const { isTeacher, student } = useGame()
  // Logged-in student who navigates to /teacher should go to the game
  if (student && !isTeacher) return <Navigate to="/play" replace />
  if (!isTeacher) return <StudentLogin />
  return <TeacherDashboard />
}

function RootRedirect() {
  const { student, isTeacher } = useGame()
  if (isTeacher) return <Navigate to="/teacher" replace />
  if (student)   return <Navigate to="/play"    replace />
  return <StudentLogin />
}

export default function App() {
  return (
    <BrowserRouter>
      <GameProvider>
        <Routes>
          <Route path="/"        element={<RootRedirect />} />
          <Route path="/play"    element={<StudentApp />} />
          <Route path="/teacher" element={<TeacherApp />} />
          <Route path="*"        element={<Navigate to="/" replace />} />
        </Routes>
      </GameProvider>
    </BrowserRouter>
  )
}
